export default {
  meta: {
    title: '分公司地图规划',
    parentPath: ['/recommend'],
    url: '/recommend/networkplaneditmap', // 埋点用，记录所属模块
    breadcrumbs: {
      path: ['/recommend/branchnetworkplan'],
      name: ['年度规划列表'],
      // noShow: true,
    },
  },
};
